var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"font-bold text-transpurple text-lg leading-24"},[_vm._t("default",[_vm._v("Add Table Title Here")])],2)}
var staticRenderFns = []

export { render, staticRenderFns }